/**
 * Exemples de code proposes par defaut a l'enseignant.
 *
 * Ces listes ne sont que des valeurs de depart, modifiables dans le panneau de
 * configuration de la lecon. Rien ici n'est impose a l'eleve : chaque panneau
 * d'aide n'apparait que si sa liste est non vide dans la configuration.
 */

import { HtmlCssHelpItem } from '../core/types';

export type HelpItem = HtmlCssHelpItem;

export const HTML_HELP_ITEMS: HtmlCssHelpItem[] = [
  { label: 'Titre 1', code: '<h1>Texte</h1>' },
  { label: 'Titre 2', code: '<h2>Texte</h2>' },
  { label: 'Titre 3', code: '<h3>Texte</h3>' },
  { label: 'Paragraphe', code: '<p>Texte</p>' },
  { label: 'Image', code: '<img src="image.jpg" alt="description" />' },
  { label: 'Lien', code: '<a href="url">Texte du lien</a>' },
  { label: 'Bouton', code: '<button>Cliquez ici</button>' },
  { label: 'Champ de saisie', code: '<input type="text" placeholder="Saisir" />' },
  { label: 'Conteneur', code: '<div>Contenu</div>' },
  { label: 'Texte en ligne', code: '<span>Texte</span>' },
];

export const CSS_HELP_ITEMS: HtmlCssHelpItem[] = [
  { label: 'Couleur du texte', code: 'color: blue;' },
  { label: 'Couleur de fond', code: 'background-color: #f0f0f0;' },
  { label: 'Taille du texte', code: 'font-size: 16px;' },
  { label: 'Graisse du texte', code: 'font-weight: bold;' },
  { label: 'Marge externe', code: 'margin: 10px;' },
  { label: 'Marge interne', code: 'padding: 10px;' },
  { label: 'Bordure', code: 'border: 1px solid black;' },
  { label: 'Coins arrondis', code: 'border-radius: 4px;' },
  { label: 'Affichage', code: 'display: flex;' },
  { label: 'Largeur', code: 'width: 100%;' },
];

/**
 * Exemples de selecteurs proposes a l'enseignant.
 *
 * Cette liste n'est plus injectee automatiquement dans la vue eleve : elle sert
 * de point de depart dans le panneau de configuration, ou l'enseignant choisit
 * de l'activer, de l'adapter ou de la laisser vide.
 */
export const SELECTOR_HELP_ITEMS: HtmlCssHelpItem[] = [
  { label: 'Element', code: 'p { }' },
  { label: 'Classe', code: '.ma-classe { }' },
  { label: 'Identifiant', code: '#mon-id { }' },
  { label: 'Descendant', code: 'div p { }' },
  { label: 'Enfant direct', code: 'div > p { }' },
  { label: 'Pseudo-classe', code: 'a:hover { }' },
];
